import fetchUsage from "@shared/services/usage-explorer/fetchUsage.ts";
import fetchUsageCsv from "@shared/services/usage-explorer/fetchUsageCsv.ts";
import fetchUsageFilters from "@shared/services/usage-explorer/fetchUsageFilters.ts";
import fetchConsumption from "@shared/services/usage-explorer/fetchConsumption.ts";
import fetchConsumptionCsv from "@shared/services/usage-explorer/fetchConsumptionCsv.ts";
import fetchUsageExplorerFeatureFlags from "@shared/services/usage-explorer/fetchUsageExplorerFeatureFlags.ts";

export const usageExplorer = {
  fetchUsage,
  fetchUsageCsv,
  fetchUsageFilters,
  fetchConsumption,
  fetchConsumptionCsv,
  fetchUsageExplorerFeatureFlags,
};
